module.exports = "<my-requestaction-grid [showRequestDetails]='true' [showSearch]='true'></my-requestaction-grid>"